import React, { useState } from "react";
import Layout from "../../../components/Accounts/Layout";
import RadioButtonComponent from "../../../components/RadioButtonComponent";
import { date, options, schedulePeriod } from "../data";
import { styled } from "styled-components";
import { TransferTitleSubTitle } from ".";
import TransferPeriod from "../../../components/Accounts/TransferPeriod";
import InputContainer from "../../../components/Accounts/InputContainer";
import Button from "../../../components/Button/Button";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { setFormValues } from "../../../store/formValues";
import { RootState } from "../../../store/rootReducer";

interface ScheduleTransferOptionProps {
  handleNext: (step: number) => void;
  prevValues: any;
  transferType: string;
}

const ScheduleTransferOption: React.FC<ScheduleTransferOptionProps> = ({
  handleNext,
  prevValues,
  transferType,
}) => {
  const dispatch = useDispatch();
  const formValues = useSelector(
    (state: RootState) => state.formValues.fipayTransfer
  );
  const [scheduleTransfer, setScheduleTransfer] = useState("");
  const [activePeriod, setActivePeriod] = useState(0);

  const onTypeChange = (option: string) => {
    setScheduleTransfer(option);
  };
  const handlePeriodClick = (index: number) => {
    setActivePeriod(index);
  };

  return (
    <>
      <Layout height="34.6875rem">
        <Formik
          initialValues={{
            startDate: formValues?.startDate || null,
            endDate: formValues?.endDate || null,
          }}
          onSubmit={(values) => {
            handleNext(2);
            const formData = {
              ...prevValues,
              ...values,
              period:
                scheduleTransfer === "yes"
                  ? schedulePeriod[activePeriod].key
                  : "no",
              scheduleTransfer: scheduleTransfer === "yes",
            };
            console.log("Values:", values);
            dispatch(setFormValues({ [transferType]: formData }));
          }}
        >
          {(formik) => (
            <form onSubmit={formik.handleSubmit} style={{ height: "100%" }}>
              <div>
                <TransferTitleSubTitle>
                  Do you want to schedule this transfer
                </TransferTitleSubTitle>
                <CheckBoxStyle>
                  <RadioButtonComponent
                    itemTypes={options}
                    onTypeChange={onTypeChange}
                    activeType={""}
                  />
                </CheckBoxStyle>
              </div>
              {scheduleTransfer === "yes" && (
                <>
                  <Period>
                    {schedulePeriod.map((period, index) => (
                      <TransferPeriod
                        period={period.value}
                        isActive={index === activePeriod}
                        key={period.key}
                        onClick={() => handlePeriodClick(index)}
                      />
                    ))}
                  </Period>

                  {date.map((input) => (
                    <InputContainer
                      name={input.name}
                      label={input.label}
                      type={input.type}
                      placeholder={input.placeholder}
                      value={
                        formik.values[
                          input.name as keyof typeof formik.values
                        ] || ""
                      }
                      onChange={formik.handleChange}
                      width={"100%"}
                      icon={input.icon}
                      error={
                        formik.touched[
                          input.name as keyof typeof formik.touched
                        ] &&
                        formik.errors[input.name as keyof typeof formik.errors]
                      }
                      style={{ padding: "1.5rem 0" }}
                    />
                  ))}
                </>
              )}
              <ButtonStyle scheduleTransfer={!!scheduleTransfer}>
                <Button
                  id={""}
                  type="submit"
                  padding={"10px 45%"}
                  title={"Next"}
                  border="10px"
                  green
                  disabled={!formik.isValid || !scheduleTransfer}
                />
              </ButtonStyle>
            </form>
          )}
        </Formik>
      </Layout>
    </>
  );
};

export default ScheduleTransferOption;

export const CheckBoxStyle = styled.div`
  display: flex;
  align-items: center;
  @media screen and (max-width: 767px) {
  }
`;

export const Period = styled.div`
  display: flex;
  gap: 1rem;
  @media screen and (max-width: 767px) {
  }
`;

export const ButtonStyle = styled.div<{ scheduleTransfer: boolean }>`
  position: absolute;
  bottom: 1rem;
  width: 88%;
  @media screen and (max-width: 767px) {
    width: 82%;
  }
`;
